import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../app/_services/app.service';
import { Router } from '@angular/router';
import { RatingModule } from 'ngx-bootstrap';

@Component({
    selector: 'app-ntw-card',
    templateUrl: './ntw-card.component.html',
    styleUrls: ['./ntw-card.component.scss'],

})
export class NtwCardComponent implements OnInit {
    // @Input() getdata: any;
    // val: number = 3;
    NetworkSearchData: any = {};
    CardData: any = [];
    TenantId;
    mailText: string = "";
    max = 5;
    rate = 3;
    isReadonly = false;
    @Output() OnEditNetwork = new EventEmitter<string>();


    constructor(
        private _appService: appService,
        private toastr: ToastrService,
        public datepipe: DatePipe,
        private router: Router
    ) { }

    ngOnInit() {
        this.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
        this.NetworkSearchData.TenantId = this.TenantId;
        this.NetworkSearchData.Status = "All";
        this.GetNetworkCardData();
    }

    GetNetworkCardData() {
        this._appService.Post("Network", "GetNetworkCardData", this.NetworkSearchData).subscribe(response => {
            if (response != null)
                this.CardData = response;
        }, err => {
            this.toastr.error("Error occurred while fetching data !", 'error');
        });
    }


    OnEditCard(Id) {
        var PostData: any = {};
        PostData.Id = Id;
        PostData.Action = 'Edit';
        this.OnEditNetwork.emit(PostData);
    }

    OnDeleteCard(Id) {
        var PostData: any = {};
        PostData.Id = Id;
        PostData.Action = 'Delete';
        this.OnEditNetwork.emit(PostData);
    }

    SendEmail(EmailId) {
        window.open('mailto:' + EmailId);
    }

    DialPhoneNumber(No) {
        window.open('tel:' + No);
    }

    SendWhatsAppMsg(No) {
        window.open('https://api.whatsapp.com/send?phone=' + No + '&text=hello from ifreightbox');
    }

}
